export default __webpack_public_path__ + "static/allLogosMobile-897023df332ae33ae38f4dd1e8b7f349.svg";